import { ConnectionNames } from "../Contracts";
import { createSportsbookConnection } from "../C_Sportsbook/Helpers";
import { createBetSlipConnection } from "../C_Betslip/Helpers";
import { createCaptorConnection } from "../C_Captor/Helpers";
import { createRealityCheckConnection } from "../C_RealityCheck/Helpers";
import { createSearchConnection } from "../C_Search/Helpers";
import { createPlayerDataConnection } from "../C_PlayerData/Helpers";
import { createBetsReportingConnection } from "../C_BetsReporting/Helpers";
import { createCasinoConnection } from "../C_Casino/Helpers";
import { createCasinoPlayerActivityConnection } from "../C_CasinoPlayerActivityAPI/Helpers";
export const ConnectionsFactory = {
    [ConnectionNames.sports]: createSportsbookConnection,
    [ConnectionNames.betslip]: createBetSlipConnection,
    [ConnectionNames.captor]: createCaptorConnection,
    [ConnectionNames.realityCheck]: createRealityCheckConnection,
    [ConnectionNames.search]: createSearchConnection,
    [ConnectionNames.player]: createPlayerDataConnection,
    [ConnectionNames.betsReporting]: createBetsReportingConnection,
    [ConnectionNames.casino]: createCasinoConnection,
    [ConnectionNames.casinoPlayerActivity]: createCasinoPlayerActivityConnection
};
//# sourceMappingURL=ConnectionsFactory.js.map